import { singOut, isUserLogin } from "@/common/empoyeerFunctions";
import { resetEmployer } from "@/store/employerSlice";

const getCookie = (name) => {
    if (typeof document === "undefined") return null;

    const match = document.cookie.match(
        new RegExp("(^| )" + name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + "=([^;]+)")
    );

    return match ? decodeURIComponent(match[2]) : null;
};


const runAuthCheck = ({
    router,
    dispatch,
    forgotPassword,
    setIsLoggedIn,
}) => {
    const REQUIRED_COOKIES = [
        "HireSide_Employers_AccessToken",
        "HireSide_Employers_UserInfo",
    ];
    for (const cookieName of REQUIRED_COOKIES) {
        if (!getCookie(cookieName)) {
            singOut();
            dispatch(resetEmployer());
            if (!forgotPassword) {
                router.replace("/employer?show_signup=true");
            }
            return false;
        }
    }
    const loggedIn = isUserLogin();
    setIsLoggedIn(loggedIn);
    return loggedIn;
};

export const initEmployerAuthListener = ({
    router,
    dispatch,
    forgotPassword = false,
    setIsLoggedIn,
}) => {
    if (typeof window === "undefined") return () => { };
    runAuthCheck({ router, dispatch, forgotPassword, setIsLoggedIn });
    const onUserStateChanges = () => {
        runAuthCheck({ router, dispatch, forgotPassword, setIsLoggedIn });
    };

    window.addEventListener("userStateChanges", onUserStateChanges);
    return () => {
        window.removeEventListener("userStateChanges", onUserStateChanges);
    };
};
